<gl-base-modal (closeModal)="onClose()">
  <h2 class="title">{{ 'save_current_project' | translate }}</h2>
  <p class="info">{{ 'new_project_message' | translate }}</p>
  <form [formGroup]="form">
    <label class="nameLabel">{{'project_name' | translate}}</label>
    <gl-input-container>
      <input
        type="text"
        normal-input
        formControlName="name"
      />
    </gl-input-container>
    <p class="info">{{ projectDescription }}</p>
    <div class="textarea-wrapper">
      <div class="projectNotes">{{ 'project_notes' | translate }}:</div>
      <textarea
        class="textarea"
        formControlName="note"
        maxlength="500"
      ></textarea>
    </div>
    <div class="buttons">
      <button normal-outline-button (click)="newProjectWithoutSaving()">{{ 'new_project' | translate }}</button>
      <button outline-button (click)="newProjectWithSaving()">{{ 'save' | translate }}</button>
    </div>
  </form>
</gl-base-modal>
